export default {
  localStorageChange: "localStorageChange",
	openLoginField: 'openLoginField'
};